// src/hooks/useAuth.js
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { logout, clearError } from "@/store/slices/authSlice";

export const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // NEW: stats is now part of the selector
  const { user, token, stats, isAuthenticated, isLoading, error } = useSelector(
    (state) => state.auth
  );

  const handleLogout = () => {
    dispatch(logout());
    navigate("/");
  };

  const clearErrors = () => {
    dispatch(clearError());
  };

  return {
    user,
    stats,
    token,
    isAuthenticated,
    isLoading,
    error,
    logout: handleLogout,
    clearErrors,
    // Role helpers
    isAdmin: user?.role === 'admin',
    isModerator: user?.role === 'moderator',
    isAdminOrModerator: user?.role === 'admin' || user?.role === 'moderator',
    hasPermission: (perm) => user?.role === 'admin' || user?.moderator_permissions?.includes(perm),
  };
};
